const TRACKING_PAGE = {
    HOMEPAGE: 'HOMEPAGE',
    CATEGORY_LEVEL2: 'CATEGORY_LEVEL2',
    SEARCH: 'SEARCH',
    ACCOUNT: 'ACCOUNT',
    CHECKOUT_CART: 'CHECKOUT_CART',
    CHECKOUT_PREVIEW: 'CHECKOUT_PREVIEW',
    CHECKOUT_PREVIEW_GUEST: 'CHECKOUT_PREVIEW_GUEST',
    CHECKOUT_FINISH: 'CHECKOUT_FINISH',
    CHECKOUT: 'CHECKOUT',
    CONTENT: 'CONTENT',
    CONTENT_BRAND: 'CONTENT_BRAND',
    CONTENT_ABOUT: 'CONTENT_ABOUT',
    MAGAZINE: 'MAGAZINE',
    VETERINARY: 'VETERINARY',
    SUPPORT: 'SUPPORT',
    CATEGORY_LEVEL3: 'CATEGORY_LEVEL3',
    CATEGORY_LEVEL4: 'CATEGORY_LEVEL4',
    ACCOUNT_HOMEPAGE: "ACCOUNT_HOMEPAGE",
    ACCOUNT_ORDERS: "ACCOUNT_ORDERS",
    ACCOUNT_ORDERS_DETAIL: "ACCOUNT_ORDERS_DETAIL",
    ACCOUNT_ORDERS_DELIVERY: "ACCOUNT_ORDERS_DELIVERY",
    ACCOUNT_REORDER: "ACCOUNT_REORDER",
    ACCOUNT_AUTOSHIPMENT: "ACCOUNT_AUTOSHIPMENT",
    ACCOUNT_WISHLIST: "ACCOUNT_WISHLIST",
    ACCOUNT_STAMPCARDS: "ACCOUNT_STAMPCARDS",
    ACCOUNT_COUPONS: "ACCOUNT_COUPONS",
    ACCOUNT_FEEDBACK_PICTURE: "ACCOUNT_FEEDBACK_PICTURE",
    ACCOUNT_NEWSLETTER: "ACCOUNT_NEWSLETTER",
    ACCOUNT_INVITATIONS: "ACCOUNT_INVITATIONS",
    ACCOUNT_LOGIN: "ACCOUNT_LOGIN",
    FEEDBACK_REVIEW: "FEEDBACK_REVIEW",
    FEEDBACK_PICTURE: "FEEDBACK_PICTURE",
    FEEDBACK_PICTURE_UPLOAD: "FEEDBACK_PICTURE_UPLOAD",
    BLOG: "BLOG",
    AFFILIATES: "AFFILIATES",
    NEWSLETTER: "NEWSLETTER",
    NEWSLETTER_SUBSCRIBE: "NEWSLETTER_SUBSCRIBE",
    NEWSLETTER_UNSUBSCRIBE: "NEWSLETTER_UNSUBSCRIBE",
    AUTOSHIPMENT: "AUTOSHIPMENT",
    INVITATIONS: "INVITATIONS",
    STAMPCARDS: "STAMPCARDS",
    MAGAZINE_HOMEPAGE: "MAGAZINE_HOMEPAGE",
    MAGAZINE_SEARCH: "MAGAZINE_SEARCH",
    MAGAZINE_LEVEL2: "MAGAZINE_LEVEL2",
    MAGAZINE_LEVEL3: "MAGAZINE_LEVEL3",
    MAGAZINE_LEVEL4: "MAGAZINE_LEVEL4",
    VETERINARY_FAQ: "VETERINARY_FAQ",
    VETERINARY_HELP: "VETERINARY_HELP",
    SERVICES_HOMEPAGE: "SERVICES_HOMEPAGE",
    SERVICES_ZOOEXPERTS: "SERVICES_ZOOEXPERTS",
    SERVICES: "SERVICES",
    "PRODUCT-DETAIL": "PRODUCT-DETAIL",
    CHECKOUT_LOGIN: "CHECKOUT_LOGIN",
    "CHECKOUT_EDIT-DATA": "CHECKOUT_EDIT-DATA",
    CHECKOUT_LOGOUT: "CHECKOUT_LOGOUT",
    CHECKOUT_REGISTER: "CHECKOUT_REGISTER",
    "CHECKOUT_EXTRA_PAYMENT-DATA": "CHECKOUT_EXTRA_PAYMENT-DATA",
    PAYMENT_EXTERNAL_ADYEN: "PAYMENT_EXTERNAL_ADYEN",
    "PAYMENT_EXTERNAL_APPLE-PAY": "PAYMENT_EXTERNAL_APPLE-PAY",
    PAYMENT_EXTERNAL_BRAINTREE: "PAYMENT_EXTERNAL_BRAINTREE",
    PAYMENT_EXTERNAL_PAYPAL: "PAYMENT_EXTERNAL_PAYPAL",
    PAYMENT_EXTERNAL_SEPA: "PAYMENT_EXTERNAL_SEPA",
    PAYMENT_EXTERNAL_TWINT: "PAYMENT_EXTERNAL_TWINT",
    "ACCOUNT_CUSTOMER-PROFILE": "ACCOUNT_CUSTOMER-PROFILE",
    "ACCOUNT_BONUS-POINTS": "ACCOUNT_BONUS-POINTS",
    "ACCOUNT_BONUS-POINTS_PRODUCTS": "ACCOUNT_BONUS-POINTS_PRODUCTS",
    "ACCOUNT_BONUS-POINTS_PRODUCT": "ACCOUNT_BONUS-POINTS_PRODUCT",
    "ACCOUNT_PET-PROFILE": "ACCOUNT_PET-PROFILE",
    "ACCOUNT_SAVINGS-PLAN": "ACCOUNT_SAVINGS-PLAN",
    "STOCK-REMINDER": "STOCK-REMINDER",
    "BONUS-POINTS": "BONUS-POINTS",
    "SPECIAL-OFFERS": "SPECIAL-OFFERS",
    "SAVINGS-PLAN": "SAVINGS-PLAN",
    "OWN-BRANDS": "OWN-BRANDS",
    "SERVICES_PUPPY-CLUB": "SERVICES_PUPPY-CLUB",
    "SERVICES_KITTEN-CLUB": "SERVICES_KITTEN-CLUB",
    "SERVICES_VIDEO-CONSULTATION": "SERVICES_VIDEO-CONSULTATION"
};
const TRACKING_EVENT = {
    EXPERIMENT: "EXPERIMENT",
    PAGE_VIEW: "PAGE_VIEW",
    VIEW_CART: "VIEW_CART",
    BEGIN_CHECKOUT: "BEGIN_CHECKOUT",
    PURCHASE: "PURCHASE",
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    CLICK: "CLICK",
    IMPRESSION: "IMPRESSION",
    INTERACTION: "INTERACTION",
    VIEW_ITEM: "VIEW_ITEM",
    VIEW_ITEM_LIST: "VIEW_ITEM_LIST"
};
const EXPERIMENT_TOOL = {
    OPTIMIZELY: "OPTIMIZELY",
    ADOBE_TARGET: "ADOBE_TARGET"
};
const DISCOUNT_TYPE = {
    COUPON: "COUPON",
    PRODUCT_GROUP: "PRODUCT_GROUP",
    NEW_CUSTOMER: "NEW_CUSTOMER",
    FREE_SHIPPING: "FREE_SHIPPING",
    SAVINGS_PLAN: "SAVINGS_PLAN",
    FIRST_ORDER_DISCOUNT: "FIRST_ORDER_DISCOUNT",
    CUSTOMER_GROUP: "CUSTOMER_GROUP",
};
const FEE_TYPE = {
    SHIPPING: "SHIPPING",
    LOGISTICS: "LOGISTICS",
    OVERWEIGHT: "OVERWEIGHT",
    PAYMENT: "PAYMENT",
};
const PLATFORM_TYPE = {
    WEB: "WEB",
    IOS: "IOS",
    ANDROID: "ANDROID",
};

export { DISCOUNT_TYPE, EXPERIMENT_TOOL, FEE_TYPE, PLATFORM_TYPE, TRACKING_EVENT, TRACKING_PAGE };
//# sourceMappingURL=constants.js.map
